import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MessageDisplayService {

  constructor(public snackBar: MatSnackBar,
              private translate: TranslateService) {
  }

  info(message: string, duration: number = 5000): void {
    this.display(message, 'info', duration);
  }

  warn(message: string, duration: number = 5000): void {
    this.display(message, 'warn', duration);
  }

  error(message: string, duration: number = 5000): void {
    this.display(message, 'error', duration);
  }

  private display(message: string, type: string, duration: number): void {
    this.translate.get('key__label_close')
      .subscribe(closeMessage => {
        this.snackBar.open(message, closeMessage, {
          duration: duration,
          panelClass: `message-display-${type}`
        });
      });
  }
}
